module.exports = __webpack_public_path__ + "static/media/Outer_fruit_2.d10688ce.svg";